

import VueRouter from 'vue-router';
import StoryCategoryFilter from './components/stories/stories-root.vue';
Vue.use(VueRouter);

const routes = [
    { path: '/:locale/:in-depth/:category/:slug?' },
    { path: '/:locale/:verdieping/:category/:slug?' },
    { path: '/:locale/:news/:category/:slug?' },
    { path: '/:locale/:nieuws/:category/:slug?' },
];

const router = new VueRouter({
    mode: 'history',
    routes // short for `routes: routes`
})

const app = new Vue({
    el: '#stories',
    router,
    components: {
        'alf-stories': StoryCategoryFilter
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/site/newsitems.js